import { render, staticRenderFns } from "./ModalChangeEmailPhone.vue?vue&type=template&id=caedef6e&scoped=true&"
import script from "./ModalChangeEmailPhone.vue?vue&type=script&lang=js&"
export * from "./ModalChangeEmailPhone.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeEmailPhone.vue?vue&type=style&index=0&id=caedef6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caedef6e",
  null
  
)

export default component.exports